import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminSkillGroupsRoutes: RouteObject[] = [
  {
    path: 'admin/skill-groups',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_GROUPS, title: 'Groupes de compétences' },
  },
  {
    path: 'admin/skill-groups/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_GROUP_CREATE, title: 'Nouveau groupe de compétences' },
  },
  {
    path: 'admin/skill-groups/:skillGroupId/edit',
    Component: Outlet,
    handle: {
      context: CONTEXTS.ADMIN_SKILL_GROUP_FORM,
      title: 'Modifier le groupe de compétences',
    },
  },
];
